import React, { FC } from 'react'
import OuthouseCompaniesListContainer from 'containers/OuthouseCompanies/OuthouseCompaniesList'

const OuthouseCompaniesListPage: FC = () => <OuthouseCompaniesListContainer />

export default OuthouseCompaniesListPage
